/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */

import type { DataMessageResponse_SupermarketPreferences_ } from "../models/DataMessageResponse_SupermarketPreferences_";
import type { DataResponse_SupermarketPreferences_ } from "../models/DataResponse_SupermarketPreferences_";
import type { SupermarketPreferences } from "../models/SupermarketPreferences";
import type { CancelablePromise } from "../core/CancelablePromise";
import { OpenAPI } from "../core/OpenAPI";
import { request as __request } from "../core/request";
export class SupermarketService {
  /**
   * Get Supermarket Options
   * Get main supermarket options for frontend UI.
   * @returns DataMessageResponse_SupermarketPreferences_ Successful Response
   * @throws ApiError
   */
  public static getSupermarketOptionsApiV1SupermarketsOptionsGet(): CancelablePromise<DataMessageResponse_SupermarketPreferences_> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/supermarkets/options",
    });
  }
  /**
   * Get Supermarket Preferences
   * Returns the supermarket preferences for a user.
   * @param xUserId
   * @returns DataResponse_SupermarketPreferences_ Successful Response
   * @throws ApiError
   */
  public static getSupermarketPreferencesApiV1SupermarketsPreferencesGet(
    xUserId: string,
  ): CancelablePromise<DataResponse_SupermarketPreferences_> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/supermarkets/preferences",
      headers: {
        "x-user-id": xUserId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Update Supermarket Preferences
   * Updates the supermarket preferences for a user.
   * @param xUserId
   * @param requestBody
   * @returns DataMessageResponse_SupermarketPreferences_ Successful Response
   * @throws ApiError
   */
  public static updateSupermarketPreferencesApiV1SupermarketsPreferencesPut(
    xUserId: string,
    requestBody: SupermarketPreferences,
  ): CancelablePromise<DataMessageResponse_SupermarketPreferences_> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/v1/supermarkets/preferences",
      headers: {
        "x-user-id": xUserId,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        422: `Validation Error`,
      },
    });
  }
}
